import { Button } from "@/components/ui/button"

const ALL_PERMISSIONS = [
  'create', 'read', 'write', 'delete', 'invoke', 'deploy',
  'access', 'subscribe', 'unsubscribe', 'suspend', 'activate',
  'download', 'update', 'publish',
]

interface PermissionsToggleControlProps {
  value: string[]
  onChange: (permissions: string[]) => void
  disabled?: boolean
}

export function PermissionsToggleControl({ value, onChange, disabled = false }: PermissionsToggleControlProps) {
  const toggle = (permission: string) => {
    if (disabled) return
    if (value.includes(permission)) {
      onChange(value.filter((p) => p !== permission))
    } else {
      onChange([...value, permission])
    }
  }

  return (
    <div className="flex flex-wrap gap-2">
      {ALL_PERMISSIONS.map((permission) => {
        const isSelected = value.includes(permission)
        return (
          <Button
            key={permission}
            type="button"
            size="sm"
            variant={isSelected ? "default" : "outline"}
            className={isSelected ? "bg-primary text-primary-foreground" : ""}
            disabled={disabled}
            onClick={() => toggle(permission)}
          >
            {permission}
          </Button>
        )
      })}
    </div>
  )
}
